<nav class="nav-drawer" [class.open]="isOpen">
    <div class="drawer-header">
      <div class="drawer-logo-container">
        <div class="drawer-logo-card">
          <img src="assets/images/SOMOS QR+_LOGO WHITE.png" alt="SOMOS QR+" class="drawer-logo-img"/>
        </div>
      </div>

    </div>


    <div class="drawer-content">
        <div
                class="drawer-item"
                routerLink="/dashboard"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
        >
            <span class="drawer-text">{{menuLabels.dashboard}}</span>
        </div>
        <div class="drawer-item" routerLink="/quality_scorecard" routerLinkActive="active">
            <span class="drawer-text">{{menuLabels.qualityScorecard}}</span>
        </div>
        <div class="drawer-item" *ngIf="showRiskAdjustmentScorecard" routerLink="/risk_adjustment_scorecard" routerLinkActive="active">
            <span class="drawer-text">{{menuLabels.riskAdjustmentScorecard}}</span>
        </div>
        <div class="drawer-item" routerLink="/schedule" routerLinkActive="active">
            <span class="drawer-text">{{menuLabels.mySchedule}}</span>
        </div>
        <div class="drawer-item" routerLink="/patient" routerLinkActive="active">
            <span class="drawer-text">{{menuLabels.myPatients}}</span>
        </div>
        <div class="drawer-item" routerLink="/reports" routerLinkActive="active">
            <span class="drawer-text">{{menuLabels.reports}}</span>
        </div>
        <div class="drawer-item" routerLink="/pocket_guides" routerLinkActive="active">
            <span class="drawer-text">{{menuLabels.pocketGuides}}</span>
        </div>

        <div class="drawer-divider"></div>

        <div class="drawer-item" routerLink="/settings" routerLinkActive="active">
            <span class="drawer-text">{{menuLabels.settings}}</span>
        </div>
        <div class="drawer-item" (click)="logout()">
            <span class="drawer-text">{{menuLabels.logout}}</span>
        </div>
    </div>
</nav>
